import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAgentActivityLogs } from "../thunk";

interface ActivityLogMetadata {
  targetValue?: string;
  actualOrders?: number;
  shortfall?: number;
  period?: string;
  totalSales?: number;
  earnings?: number;
  checkType?: string;
}

interface ActivityLog {
  _id: string;
  agentId: string;
  eventType: string;
  action: string;
  description: string;
  metadata: ActivityLogMetadata;
  createdAt: string;
  __v: number;
}

interface AgentsState {
  activityLogs: ActivityLog[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: AgentsState = {
  activityLogs: [],
  status: "idle",
  error: null,
};

const agentsSlice = createSlice({
  name: "agents",
  initialState,
  reducers: {
    clearActivityLogs: (state) => {
      state.activityLogs = [];
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAgentActivityLogs.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAgentActivityLogs.fulfilled, (state, action: PayloadAction<ActivityLog[]>) => {
        state.status = "succeeded";
        state.activityLogs = action.payload;
        state.error = null;
      })
      .addCase(getAgentActivityLogs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string || "Failed to fetch agent activity logs";
      });
  },
});

export const { clearActivityLogs, clearError } = agentsSlice.actions;
export default agentsSlice.reducer;
